import { useCallback } from "react";
import {
  webLogItemKind,
  webLogPageCategory,
  webLogScreenName,
  webLogEventName,
} from "@types";
import { FilterIsolationType } from "@types";
import { sendClickLog } from "@weblog";

const baseFilterLog = {
  screenName: webLogScreenName.travelscanner,
  pageCategory: webLogPageCategory.title,
  eventName: webLogEventName.filter,
  itemKind: webLogItemKind.filter,
}

export function useFilterWebLog() {
  const handleVaccinationLog = useCallback(() => {
    try {
      sendClickLog({
        ...baseFilterLog,
        filterDetail: {
          vaccine_name: '1',
        },
      });
    } catch (e) {
      // ignore
    }
  }, []);
  const handleIsolationLog = useCallback((filterIsolation: FilterIsolationType) => {
    try {
      const checkValues = Object.values(filterIsolation)?.filter(Boolean) ?? [];
      const hasValue = checkValues.length > 0;

      sendClickLog({
        ...baseFilterLog,
        filterDetail: {
          quarantine_place: hasValue ? '1' : '0',
        },
      });
    } catch (e) {
      // ignore
    }
  }, []);

  return {
    sendVaccinationFilterLog: handleVaccinationLog,
    sendIsolationFilterLog: handleIsolationLog,
  }
}
